import { Link } from 'react-router-dom';
import { useSEO } from '@/hooks/useSEO';
import { videos, categories, featuredVideoIds, trendingVideoIds, newestVideoIds } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

const featuredVideos = videos.filter((v) => featuredVideoIds.includes(v.id));
const trendingVideos = videos.filter((v) => trendingVideoIds.includes(v.id));
const newestVideos = videos.filter((v) => newestVideoIds.includes(v.id));

export default function Home() {
  useSEO({
    title: '神马视频 - 香蕉视频、红桃视频免费在线观看全集 | 蜜桃视频樱桃视频高清不缓冲在线观看电影',
    description: '神马视频为您提供香蕉视频、红桃视频、蜜桃视频、樱桃视频等水果视频品牌的高清免费在线观看，电视剧电影全集不缓冲播放，视频网站一网打尽。海量影视资源每日更新，极速加载高清流畅。',
    keywords: '香蕉视频,红桃视频,蜜桃视频,樱桃视频,神马视频,免费在线观看,高清不缓冲,电影全集,视频在线观看,水果视频网站',
  });

  return (
    <>
      <section className="relative h-[420px] md:h-[600px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20interior%20with%20large%20projection%20screen%20showing%20colorful%20abstract%20film%20reel%20graphics%2C%20warm%20theater%20lighting%2C%20empty%20red%20velvet%20seats%2C%20atmospheric%20movie%20theater%20ambiance%2C%20dramatic%20spotlight%20effects%2C%20professional%20cinema%20photography%2C%20rich%20dark%20tones%20with%20warm%20accents&width=1600&height=900&seq=hero-bg-shenma&orientation=landscape"
          alt="神马视频 - 水果视频品牌高清在线观看"
          className="absolute inset-0 w-full h-full object-cover object-top"
          title="神马视频首页背景"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/40 to-background-950/80"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-2xl">
              <h1 className="text-3xl md:text-5xl font-bold text-background-50 font-heading leading-tight">
                水果视频品牌<br />高清免费在线观看
              </h1>
              <p className="mt-4 md:mt-6 text-sm md:text-base text-background-200 max-w-lg leading-relaxed">
                神马视频汇集香蕉视频、红桃视频、蜜桃视频、樱桃视频等品牌，海量电影电视剧免费在线观看，高清不缓冲，每日更新
              </p>
              <div className="flex flex-wrap gap-3 mt-6 md:mt-8">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="px-5 py-2.5 rounded-full text-sm font-medium bg-background-50/15 text-background-50 backdrop-blur-sm border border-background-50/20 hover:bg-background-50/25 transition-all whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <main className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <section className="mb-12 md:mb-16">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                精选推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-1">编辑精选，不容错过的精彩内容</p>
            </div>
            <Link
              to="/category/xiangjiao"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
            >
              查看更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {featuredVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </section>

        <section className="mb-12 md:mb-16">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                热门排行
              </h2>
              <p className="text-sm text-foreground-500 mt-1">全网热播，大家都在看</p>
            </div>
            <Link
              to="/category/hongtao"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
            >
              查看更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {trendingVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </section>

        <section className="mb-12 md:mb-16">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                最新上线
              </h2>
              <p className="text-sm text-foreground-500 mt-1">新鲜出炉，第一时间观看</p>
            </div>
            <Link
              to="/category/yingtao"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
            >
              查看更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {newestVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </section>

        <section className="bg-background-100 rounded-xl p-6 md:p-10">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-4">
              为什么选择神马视频？
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-8">
              <div className="text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-movie-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">海量资源</h3>
                <p className="mt-1 text-xs text-foreground-500">四大水果品牌，万部影视内容每日更新</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-speed-up-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">高清不缓冲</h3>
                <p className="mt-1 text-xs text-foreground-500">4K超清画质，智能CDN加速，播放流畅</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-shield-check-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">安全免费</h3>
                <p className="mt-1 text-xs text-foreground-500">完全免费在线观看，无需注册无广告</p>
              </div>
            </div>
          </div>
        </section>

        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "神马视频",
            "url": "https://www.shenmashipin.com/",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://www.shenmashipin.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            },
            "description": "神马视频为您提供香蕉视频、红桃视频、蜜桃视频、樱桃视频等水果视频品牌的高清免费在线观看服务。"
          })
        }} />

        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "神马视频首页 - 水果视频品牌高清免费在线观看",
            "url": "https://www.shenmashipin.com/",
            "description": "神马视频汇集香蕉视频、红桃视频、蜜桃视频、樱桃视频等水果视频品牌，提供海量高清影视内容免费在线观看。",
            "isPartOf": {
              "@type": "WebSite",
              "name": "神马视频",
              "url": "https://www.shenmashipin.com/"
            }
          })
        }} />
      </main>
    </>
  );
}